import { useQuery } from "@tanstack/react-query";

import { getMe } from "@/api/auth";
import { getToken } from "@/api/client";

export function useAuth() {
  const hasToken = Boolean(getToken());
  const query = useQuery({
    queryKey: ["auth", "me"],
    queryFn: getMe,
    enabled: hasToken,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    user: query.data,
    isLoading: query.isLoading,
    isAuthenticated: hasToken && Boolean(query.data),
    error: query.error,
  };
}
